import { StylesConfig } from "react-select/dist/declarations/src/styles";

// Charcoal select from the app tokens (Styles/tokens.scss); light theme swaps the tokens.
export const customStyles: StylesConfig = {
  control: (base, state) => ({
    ...base,
    minHeight: 38,
    borderRadius: 8,
    border: `1px solid ${state.isFocused ? "var(--dt-muted)" : "var(--dt-control-border)"}`,
    backgroundColor: state.isDisabled ? "var(--dt-zebra)" : "var(--dt-control)",
    boxShadow: state.isFocused
      ? "0 0 0 3px color-mix(in srgb, var(--dt-muted) 22%, transparent)"
      : "none",
    cursor: "pointer",
    "&:hover": { borderColor: "var(--dt-muted)" },
  }),
  valueContainer: (base) => ({ ...base, padding: "2px 10px" }),
  singleValue: (base) => ({
    ...base,
    color: "var(--dt-text)",
    fontSize: 13,
    fontWeight: 500,
  }),
  input: (base) => ({ ...base, margin: 0, padding: 0, color: "var(--dt-text)", fontSize: 13 }),
  placeholder: (base) => ({ ...base, color: "var(--dt-subtle)", fontSize: 13 }),
  indicatorSeparator: () => ({ display: "none" }),
  dropdownIndicator: (base) => ({
    ...base,
    padding: 6,
    color: "var(--dt-subtle)",
    "&:hover": { color: "var(--dt-text)" },
  }),
  clearIndicator: (base) => ({
    ...base,
    padding: 4,
    color: "var(--dt-subtle)",
    "&:hover": { color: "var(--dt-text)" },
  }),
  loadingIndicator: (base) => ({ ...base, color: "var(--dt-subtle)" }),
  menu: (base) => ({
    ...base,
    zIndex: "var(--z-popover)",
    marginTop: 6,
    overflow: "hidden",
    border: "1px solid var(--dt-border)",
    borderRadius: 10,
    backgroundColor: "var(--dt-surface)",
    boxShadow: "0 16px 40px rgba(0, 0, 0, 0.35)",
  }),
  menuPortal: (base) => ({ ...base, zIndex: "var(--z-popover)" }),
  menuList: (base) => ({ ...base, padding: 4 }),
  option: (base, state) => ({
    ...base,
    borderRadius: 6,
    backgroundColor: state.isSelected
      ? "var(--dt-selected)"
      : state.isFocused
        ? "var(--dt-hover)"
        : "transparent",
    color: "var(--dt-text)",
    fontSize: 13,
    fontWeight: state.isSelected ? 700 : 500,
    cursor: "pointer",
    "&:active": { backgroundColor: "var(--dt-selected)" },
  }),
  noOptionsMessage: (base) => ({ ...base, color: "var(--dt-muted)", fontSize: 13 }),
  loadingMessage: (base) => ({ ...base, color: "var(--dt-muted)", fontSize: 13 }),
  multiValue: (base) => ({
    ...base,
    margin: 2,
    border: "1px solid var(--dt-control-border)",
    borderRadius: 6,
    backgroundColor: "var(--dt-selected)",
  }),
  multiValueLabel: (base) => ({
    ...base,
    color: "var(--dt-text)",
    fontSize: 12,
    fontWeight: 700,
  }),
  multiValueRemove: (base) => ({
    ...base,
    color: "var(--dt-subtle)",
    borderRadius: "0 6px 6px 0",
    "&:hover": { backgroundColor: "var(--dt-hover)", color: "var(--dt-text)" },
  }),
};

/** Kept for existing imports; the default styles now follow the theme. */
export const customDarkStyles = customStyles;
